import request from '@/services/interceptor.js'

export const get_tipiPagamento = () => {
    return request({
        url: '/tipopagamento',
        method: 'get',
        loadingBar: true
    })
}

export const get_tipoPagamento = (id) => {
    return request({
        url: `/tipopagamento/${id}`,
        method: 'get',
        loadingBar: true
    })
}

export const create_tipoPagamento = (par) => {
    return request({
        url: '/tipopagamento',
        method: 'post',
        data: par,
        loadingBar: true
    })
}

export const update_tipoPagamento = (id, par) => {
    return request({
        url: `/tipopagamento/${id}`,
        method: 'put',
        data: par,
        loadingBar: true
    })
}

export const duplica_tipoPagamento = (id) => {
    return request({
        url: `/tipopagamento/${id}/duplica`,
        method: 'post',
        loadingBar: true
    })
}

export const delete_tipoPagamento = (id) => {
    return request({
        url: `/tipopagamento/${id}`,
        method: 'delete',
        loadingBar: true
    })
}
